var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wave",staticClass:"wave-div",style:(_vm.divStyle)},[_vm._t("default"),_vm._v(" "),_c('svg',{ref:"wall",staticClass:"wave-wall",style:(_vm.wallStyle),attrs:{"id":_vm.svgId}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e600cfe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/vue-real-wave.vue
// module id = 12
// module chunks = 0